import React from 'react';
import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import Button from '../components/Button';
import CheckoutPageHeader from '../components/checkout/CheckoutPageHeader';
import { paths } from '../config/paths';
import { v2Colors } from '../design/theme';
import PageContainer from '../layouts/PageContainer';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <PageContainer sx={{ px: { xs: 1.5, sm: 2 }, pb: 4, textAlign: 'center' }}>
      <Helmet>
        <title>Page not found | Country Chicken Co</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <CheckoutPageHeader backTo={paths.home} title="Page not found" />
      <Typography sx={{ color: v2Colors.textMuted, mb: 3, lineHeight: 1.6 }}>
        This link is not a page on Country Chicken Co.
      </Typography>
      <Button
        onClick={() => navigate(paths.home)}
        sx={{
          bgcolor: v2Colors.primary,
          '&:hover': { bgcolor: v2Colors.primaryDark },
        }}
      >
        Go to homepage
      </Button>
    </PageContainer>
  );
}
